import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import Logo from 'shared/ui/icons/General/Logo';
import LogoEn from 'shared/ui/icons/General/LogoEn';
import LogoBannerBrotherhood from 'shared/ui/icons/LogoBannerBrotherhood';
import Button from 'shared/ui/Button/Button/Button';
import {isTranslate} from 'shared/lib/lang';

import styles from './StatusPageFooter.module.scss';

const openLink = (url: string) => () => window.open(url, '_blank', 'noopener,noreferrer');

const StatusPageFooter: React.FC = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.cards}>
                <div className={styles.card}>
                    <div className={styles.cardBody}>
                        <h3 className={styles.cardTitle}>
                            {t`Проверено и работает`}<br/>
                            <span className={styles.brand}>{t`Overseer`}</span>
                        </h3>
                        <p className={styles.cardText}>
                            {t`Понравился Overseer? Тут можно узнать все возможности продукта`}
                        </p>
                        <Button
                            variant="gradient"
                            className={styles.cardButton}
                            onClick={openLink(AppUrls.MAIN_OVERSEER)}
                        >
                            {t`Перейти`}
                            <span className={styles.arrow} aria-hidden="true"/>
                        </Button>
                    </div>
                    <div className={styles.cardLogo}>
                        {isTranslate() ? <LogoEn/> : <Logo/>}
                    </div>
                </div>

                {!isTranslate() && (
                    <div className={styles.card}>
                        <div className={styles.cardBody}>
                            <h3 className={styles.cardTitle}>
                                {t`Разработано командой`}<br/>
                                <span className={styles.brand}>{t`Братство Кодеров`}</span>
                            </h3>
                            <p className={styles.cardText}>
                                {t`Понравился Overseer? Мы можем разработать веб‑проект и для вас`}
                            </p>
                            <Button
                                variant="gradient"
                                className={styles.cardButton}
                                onClick={openLink(AppUrls.MAIN_BROTHER)}
                            >
                                {t`Перейти`}
                                <span className={styles.arrow} aria-hidden="true"/>
                            </Button>
                        </div>
                        <div className={styles.cardLogo}>
                            <LogoBannerBrotherhood/>
                        </div>
                    </div>
                )}
            </div>

            <div className={styles.about}>
                <p className={styles.aboutText}>
                    <span className={styles.aboutBrand}>{t`Overseer`}</span>
                    {/* eslint-disable-next-line max-len */}
                    {t` — российская система мониторинга веб-сайтов и серверов. Оперативно выявляем сбои и предупреждаем вас раньше, чем клиенты заметят проблему. Круглосуточный мониторинг из разных геолокаций с автоматической проверкой доступности сайта, срока действия сертификатов SSL, срока регистрации доменного имени и другими возможностями.`}
                </p>
            </div>
        </footer>
    );
};

export default StatusPageFooter;
